export default {
  vi: {
    inputSearch: "Tìm kiếm..."
  },
  'en-us': {
    inputSearch: 'Search...'
  },
}
